import classNames from 'classnames';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { WorkspaceAnalyticCategoryContext } from 'shared/middlewares/analytics/loggerContext';

type RequestButtonProps = {
  className?: string;
  onRequested?: () => void;
};
export const RequestButton: FC<RequestButtonProps> = ({ className, onRequested }) => {
  const logAnalyticsCategory = useContext(WorkspaceAnalyticCategoryContext);
  const onClick = useCallback(() => {
    if (onRequested) {
      onRequested();
      logAnalytics.trackEvent(logAnalyticsCategory, 'Request price improvement');
    }
  }, [logAnalyticsCategory, onRequested]);

  const { formatMessage } = useIntl();

  return (
    <button
      className={classNames('btn btn-discreet-info btn-lg my-0', className)}
      data-e2e="price-negotiation-request-btn"
      onClick={onRequested && onClick}
      disabled={!onRequested}
      type="button"
    >
      {formatMessage({ id: 'priceImprovement.request.button.label' })}
    </button>
  );
};
